/**
 * Customers API Service
 * 
 * This module handles all customer-related API calls
 * including customer data retrieval and management.
 */

import axios from 'axios';
import API_CONFIG, { getAuthHeaders } from './config';

const customersAPI = {
  /**
   * Get customers list
   * @param {string} token - JWT access token
   * @param {Object} params - Query parameters
   * @returns {Promise<Array>} List of customers
   */
  async getCustomers(token, params = {}) {
    const queryParams = new URLSearchParams(params);
    const response = await axios.get(`${API_CONFIG.BASE_URL}/api/customers?${queryParams}`, {
      headers: getAuthHeaders(token),
      timeout: API_CONFIG.TIMEOUT
    });
    return response.data;
  },

  /**
   * Get customer by phone number
   * @param {string} token - JWT access token
   * @param {string} phone - Customer phone number
   * @returns {Promise<Object>} Customer details with orders
   */
  async getCustomerByPhone(token, phone) {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/api/customers/${phone}`, {
      headers: getAuthHeaders(token),
      timeout: API_CONFIG.TIMEOUT
    });
    return response.data;
  }
};

export { customersAPI };
